import type { ReactElement } from 'react';
import { ExternalLink } from 'lucide-react';
import { useFailClosedFlag } from '@/hooks/useFailClosedFlag';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/** Every MDM guide and download lives on the support site (behind Cloudflare Access). */
export const MDM_DEPLOYMENT_GUIDE_URL = 'https://support-downloads.knostic.ai/';

/**
 * KIR-5409: a link next to the MDM key to the MDM deployment guides on the
 * support site. Install steps live there only. Shown only with `shared_devices`.
 */
export function MdmDeployHelp(): ReactElement | null {
  const { enabled } = useFailClosedFlag(flagsmithFeatureFlags.SHARED_DEVICES);
  if (!enabled) return null;
  return (
    <a
      href={MDM_DEPLOYMENT_GUIDE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline"
    >
      Deployment guide
      <ExternalLink className="h-3 w-3" aria-hidden="true" />
    </a>
  );
}
